import { pb } from "./pocketbase";

const capitalize = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const archiveService = {
  // --- BUSCA UNIFICADA (Substitui as 7 queries do Firebase) ---
  async searchOrders(term) {
    if (!term) return [];

    const rawTerm = term.trim();
    // PocketBase usa o operador ~ para "contains" (case insensitive na maioria dos casos)
    // Vamos montar um filtro OR gigante.

    // Lista de campos flattened que podemos buscar rapido
    // Nota: Para buscar dentro do JSON (shipping.address.street), o PocketBase não indexa bem,
    // mas se o volume for baixo (<10k), funciona. 
    // Por segurança e performance, focamos nos campos Flattened e nos principais.

    const filterConditions = [
      `sku ~ "${rawTerm}"`,
      `order_number = "${rawTerm}"`, // Número exato costuma ser melhor
      `customer_name ~ "${rawTerm}"`,
      `shipping_city ~ "${rawTerm}"`,
      `shipping_state ~ "${rawTerm}"`,
      // Se quiser arriscar busca profunda (pode ser lento):
      // `full_data.shipping.address.street ~ "${rawTerm}"`
    ];

    // O filtro final deve ser: (isArchived) && (cond1 || cond2 || cond3)
    const filterQuery = `archived=true && (${filterConditions.join(" || ")})`;

    try {
      const records = await pb.collection("production_orders").getList(1, 50, {
        filter: filterQuery,
        sort: "-created",
      });

      // Mapeia para o formato esperado pelo React (se precisar)
      // O Adapter 'production_orders' já deve ter o 'full_data', mas aqui retornamos o record.
      // A UI espera 'doc.data()', entao o record do PB (que é um objeto plano) já serve bem,
      // desde que a UI saiba ler as propriedades.
      return records.items.map(item => ({
        id: item.id,
        ...item.full_data, // Espalha o full_data para recuperar a estrutura original
        ...item, // Sobrescreve com os metadados do PB (id, created, updated) se conflitar
      }));

    } catch (error) {
      console.error("ERRO NA BUSCA (PocketBase):", error);
      return [];
    }
  },

  async unarchiveOrder(orderId, userName) {
    await pb.collection("production_orders").update(orderId, {
      archived: false,
      status: "SOLICITACAO",
      // unarchivedBy: userName // Se quiser salvar no full_data ou criar coluna
    });
  },
};
